<ng-content select="[left-icon]"></ng-content>
<div class="cerrix-form-field">
    <div
        [class]="disabled ? 'cerrix-form-field-wrapper disabled' : 'cerrix-form-field-wrapper'"
        tabindex="0"
        [attr.data-uiid]="dataUiid"
        (blur)="onBlur()"
        (click)="openDialog()"
    >
        <div
            [class]="
                selection.length
                    ? 'cerrix-form-field-infix has-multi-selection'
                    : 'cerrix-form-field-infix'
            "
        >
            @if (multiple && selection.length) {
                <mat-tree
                    [dataSource]="dataSource"
                    [treeControl]="treeControl"
                    class="display-tree"
                >
                    <mat-tree-node
                        *matTreeNodeDef="let node"
                        matTreeNodePadding
                        matTreeNodePaddingIndent="20"
                        class="tree-node"
                    >
                        <button mat-icon-button disabled class="node-toggle small"></button>

                        @if (!!node.icon) {
                            <i [class]="getIcon(node)" class="node-icon"></i>
                        }
                        <span class="node-text">{{ node.name }}</span>
                    </mat-tree-node>
                    <mat-tree-node
                        *matTreeNodeDef="let node; when: hasChild"
                        matTreeNodePadding
                        matTreeNodePaddingIndent="20"
                        matTreeNodeToggle
                        class="tree-node padding"
                    >
                        <button
                            mat-icon-button
                            matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + node.name"
                            class="node-toggle small"
                            touch-target="none"
                        >
                            <mat-icon class="mat-icon-rtl-mirror icon-toggle">
                                {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
                            </mat-icon>
                        </button>
                        @if (!!node.icon) {
                            <i [class]="getIcon(node)" class="node-icon"></i>
                        }
                        <span class="node-text">{{ node.name }}</span>
                    </mat-tree-node>
                </mat-tree>
            } @else if (!multiple && selection.length === 1) {
                <div class="single-selection-value">
                    {{ selection[0].name }}
                </div>
            } @else {
                <div class="tree-placeholder">{{ placeholder }}</div>
            }
        </div>
        @if (!disabled) {
            <button
                [disabled]="disabled"
                [attr.data-uiid]="dataUiid + '-tree-toggle'"
                class="tree-toggle"
                type="button"
                mat-icon-button
            >
                <mat-icon>add</mat-icon>
            </button>
        }
    </div>

    @if (ngControl?.control?.errors) {
        <div class="cerrix-form-field-error-wrapper">
            @for (error of ngControl!.control!.errors | errorMessages; track error) {
                <div class="form-field-error">
                    {{ error }}
                </div>
            }
        </div>
    }
</div>

<ng-template #modalTemplate>
    <div mat-dialog-title>Change selection</div>
    <mat-dialog-content>
        <cerrix-tree
            #treeSelectRef
            [selection]="value"
            [treeData]="treeList"
            [multiple]="multiple"
            [dataUiid]="dataUiid"
            [includeChildren]="cascadeChildren"
            (includeChildrenChange)="toggleCascadeChildren($event)"
        ></cerrix-tree>
    </mat-dialog-content>
    <mat-dialog-actions [align]="'end'">
        <button
            type="button"
            mat-stroked-button
            [attr.data-uiid]="dataUiid + '-close-button'"
            [mat-dialog-close]="true"
        >
            <mat-icon>close</mat-icon>
            <ng-container>Cancel</ng-container>
        </button>
        <button
            type="button"
            [attr.data-uiid]="dataUiid + '-apply-button'"
            (click)="onApply()"
            mat-stroked-button
        >
            <mat-icon>check</mat-icon>
            <ng-container>Apply</ng-container>
        </button>
    </mat-dialog-actions>
</ng-template>
